module.exports = __webpack_public_path__ + "img/nav_item_bg3-active.3b38ebb6.png";